import React from 'react';
import '../../styles/components/ModalBodyConfirm.scss';
import { UnorderedList, ListItem } from '../Carbon';
import { Subject } from 'rxjs';
import { AsperaError } from '../../classes/AsperaError';
import { AsperaForm } from '../../components/AsperaForm';
import { SubManager } from '../../classes/SubManager';
import { language } from '../../services/LanguageService';
/**
 * React Component
 *
 * The ModalBodyConfirm provides a basic template for showing a confirmation modal (list is optional).
 *
 * @example
 * ```javascript
 * <ModalBodyConfirm description="Are you sure you want to do something?" list={['item1', 'item2']} warningDescription="This cannot be undone!" />
 * ```
 */
export class ModalBodyConfirm extends React.Component {
    constructor() {
        super(...arguments);
        this.validFormSubject = new Subject();
        this.subManager = new SubManager();
        this.localModel = { confirmText: '' };
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        this.subManager.unsubscribeAll();
        modalClose();
    }
    componentDidMount() {
        const { confirmText, disableSubject } = this.props;
        if (confirmText && !disableSubject) {
            new AsperaError('ModalBodyConfirm: confirmText used without disableSubject', {});
        }
        this.subManager.setSubscription(this.validFormSubject.subscribe({
            next: valid => {
                if (disableSubject) {
                    disableSubject.next(!valid);
                }
            },
            error: error => {
                new AsperaError('ModalBodyConfirm: unable to subscribe for valid form', error);
            },
        }));
    }
    render() {
        const { className, description, list, warningDescription, confirmText, disableSubject } = this.props;
        return (React.createElement("div", { className: `modal-body-confirm ${className ? className : ''}` },
            React.createElement("div", { className: "modal-body-confirm--description" }, description),
            Array.isArray(list) && React.createElement(UnorderedList, { className: "modal-body-confirm--list" }, list.map((item, index) => React.createElement(ListItem, { key: index }, item))),
            !!warningDescription && React.createElement("div", { className: "modal-body-confirm--warning-description" }, warningDescription),
            !!(confirmText && disableSubject) && (React.createElement(AsperaForm, { className: "modal-body-confirm--form", validFormSubject: this.validFormSubject, formDetails: {
                    model: this.localModel,
                    id: 'modal-body-confirm-form',
                    items: [
                        {
                            type: 'text',
                            pointer: 'confirmText',
                            required: true,
                            label: language.get('modal.typeToConfirm', [confirmText]),
                            errorText: language.get('modal.typeToConfirmError', [confirmText]),
                            validationCheck: (value) => {
                                if (value && typeof value === 'string' && confirmText && typeof confirmText === 'string') {
                                    return value.toLowerCase() === confirmText.toLowerCase();
                                }
                                return false;
                            },
                        },
                    ],
                } }))));
    }
}
